import React, { FC } from "react";

// Domain Components
import { FAQ } from "../FAQ/FAQ";
import { ReachOutToUs } from "../ReachOutToUs/ReachOutToUs";

// UI components
import { Heading } from "@UI/Components/Heading/Heading";
import { Button } from "@UI/Components/Button/Button";
import { Icon } from "@UI/Components/Icon/Icon";
import { Box } from "@UI/Components/Box/Box";
import { Drawer } from "@UI/Components/Drawer/Drawer";
import { SolidInfoCircle } from "@UI/Components/Icons/SolidInfoCircle";

// i18n
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";

// hooks
import useMediaQuery from "@UI/hooks/useMediaQuery";

export const FAQSection: FC = () => {
  const { isMobile } = useMediaQuery();
  const [showFAQ, setShowFAQ] = React.useState(false);

  const toggleFAQ = () => setShowFAQ(!showFAQ);

  if (!isMobile)
    return (
      <>
        <Heading textAlign="center" marginBottom="8">
          <FormattedMessage {...messages.doYouHaveAQuestion} />
        </Heading>
        <FAQ />
        <ReachOutToUs />
      </>
    );

  return (
    <>
      <Button
        variant="link"
        colorScheme="gray"
        marginBottom="8"
        onClick={toggleFAQ}
        width="full"
        textAlign="center"
      >
        <Icon as={SolidInfoCircle} marginRight="3" />
        <FormattedMessage {...messages.doYouHaveAQuestion} />
      </Button>
      <Drawer placement="bottom" onClose={toggleFAQ} isOpen={showFAQ}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <FAQ />
          <Box marginBottom="6">
            <ReachOutToUs />
          </Box>
        </Box>
      </Drawer>
    </>
  );
};
